import borderGetters from '@constans/store/border/borderGetters';
const getters = {
    [borderGetters.GET_BORDERS]: (state) => state.borders
};
export default getters;
